import { render, staticRenderFns } from "./MakeCutScrapList.vue?vue&type=template&id=252f6439"
import script from "./MakeCutScrapList.vue?vue&type=script&lang=js"
export * from "./MakeCutScrapList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports